import React, { useState } from 'react';

const API = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [ssoEnabled, setSsoEnabled] = useState(false);

  React.useEffect(() => {
    fetch(`${API}/api/auth/sso/status`)
      .then(r => r.json())
      .then(d => setSsoEnabled(d.enabled))
      .catch(() => {});
  }, []);

  // Check for SSO error in URL
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ssoErr = params.get('sso_error');
    if (ssoErr) setError(`SSO error: ${ssoErr}`);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || 'Login failed');
      onLogin(d.username);
    } catch(e) {
      setError(e.message);
    }
    setLoading(false);
  };

  const inputStyle = {
    width: '100%', fontFamily: 'DM Sans', fontSize: 14,
    padding: '10px 12px', border: '1px solid var(--border)',
    borderRadius: 8, outline: 'none', background: 'var(--surface)',
    boxSizing: 'border-box', marginTop: 6,
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 400, padding: 24 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="var(--accent)">
              <path d="M11.53 2c0 2.4 1.97 4.34 4.34 4.34h1.76v1.7c0 2.4 1.94 4.34 4.37 4.35V2.69a.7.7 0 0 0-.7-.69H11.53zM6.77 6.8a4.36 4.36 0 0 0 4.34 4.34h1.76v1.71a4.36 4.36 0 0 0 4.37 4.35V7.49a.7.7 0 0 0-.7-.69H6.77zM2 11.62a4.36 4.36 0 0 0 4.34 4.34h1.76v1.7A4.36 4.36 0 0 0 12.47 22v-9.31a.7.7 0 0 0-.7-.69H2z"/>
            </svg>
            <span style={{ fontSize: 22, fontWeight: 700 }}>Jira Dashboard</span>
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-2)' }}>Sign in to continue</div>
        </div>

        {/* SSO login - only show when configured */}
        {ssoEnabled && (
          <>
            <a href="/api/auth/sso/login" style={{ display:'block', width:'100%', textAlign:'center',
              padding:'10px', background:'#0078d4', color:'#fff', borderRadius:8, textDecoration:'none',
              fontFamily:'DM Sans', fontSize:14, fontWeight:600, marginBottom:16, boxSizing:'border-box' }}>
              <span style={{ marginRight:8 }}>🔑</span> Sign in with Microsoft
            </a>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:16 }}>
              <div style={{ flex:1, height:1, background:'var(--border)' }} />
              <span style={{ fontSize:11, color:'var(--text-2)' }}>or sign in with credentials</span>
              <div style={{ flex:1, height:1, background:'var(--border)' }} />
            </div>
          </>
        )}

        <form onSubmit={submit} className="card">
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-2)', display: 'block' }}>Username</label>
            <input style={inputStyle} type="text" value={username} onChange={e => setUsername(e.target.value)}
              placeholder="admin" autoComplete="username" autoFocus />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-2)', display: 'block' }}>Password</label>
            <input style={inputStyle} type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" autoComplete="current-password" />
          </div>

          {error && (
            <div style={{ marginBottom: 16, padding: '10px 14px', background: 'var(--critical-light)', borderRadius: 8, color: 'var(--critical)', fontSize: 13 }}>
              {error}
            </div>
          )}

          <button type="submit" className="btn btn-primary"
            disabled={loading || !username || !password}
            style={{ width: '100%', justifyContent: 'center', opacity: (!username || !password) ? .5 : 1, fontSize: 14, padding: '10px' }}>
            {loading ? 'Signing in…' : 'Sign in →'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 11, color: 'var(--text-2)' }}>
          Session expires after 8 hours
        </div>
      </div>
    </div>
  );
}
